module.exports = __webpack_public_path__ + "img/contenedor33.2a4391e3.png";